<template>
  <ConfirmModal
    ref="modalRef"
    :title="`Revoke the invite to ${invite?.email}?`"
    description="The link in their email stops working. You can invite them again any time."
    confirm-label="Revoke"
    width="30rem"
    :loading="isSubmitting"
    @confirm="confirm"
  />
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { ConfirmModal, useAlertsStore } from '@tallo/design-system';
import { PendingInviteDto, useRevokeInvite } from '@tallo/investor/company';

const modalRef = ref<InstanceType<typeof ConfirmModal>>();
const invite = ref<PendingInviteDto>();
const alertsStore = useAlertsStore();
const revokeInvite = useRevokeInvite();
const isSubmitting = revokeInvite.isLoading;

function open(target: PendingInviteDto) {
  invite.value = target;
  modalRef.value?.show();
}

async function confirm() {
  if (!invite.value) return;

  try {
    await revokeInvite.mutateAsync(invite.value);
    modalRef.value?.close();
    alertsStore.success('Invite revoked');
  } catch {
    // Already reported by the mutation's toast; the dialog stays open for another try
  }
}

defineExpose({ open });
</script>
